// packages/ui-kit/src/primitives/Tag.tsx
// C3F v18 — reference: design/system/components/core/Tag.{jsx,prompt.md}
// Squared descriptive label for metadata (skills, departments). NOT a status
// (that's Badge, mono pill) and NOT tappable (that's Chip): if it reacts to
// touch, use Chip. The 4px radius is what tells it apart at a glance.
import { type ReactNode } from "react";

export type TagTone = "neutral" | "accent";

interface Props {
  tone?: TagTone;
  children: ReactNode;
  className?: string;
}

// Opaque quiet grounds paired with their own ink (build.md): neutral rests on
// --bg-subtle (never a hover/active veil), accent-soft pairs only with
// --accent-text.
const toneCls: Record<TagTone, string> = {
  neutral: "bg-subtle text-fg-muted",
  accent: "bg-accent-soft text-accent-text",
};

export function Tag({ tone = "neutral", children, className = "" }: Props) {
  return (
    <span
      className={`inline-flex h-[22px] items-center whitespace-nowrap rounded-xs px-2 font-sans text-caption font-medium ${toneCls[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
